import React from 'react';
import * as Yup from 'yup';
import MasterManager from '../../components/expense/MasterManager';

const schema = Yup.object().shape({
  name: Yup.string().trim().required('Name is required').max(100),
  sortOrder: Yup.number().typeError('Sort order must be a number').integer().min(0).required('Sort order is required'),
});

// Owner: Accounts
const ExpenseCategoryMaster = ({ canEdit }) => (
  <MasterManager
    resource="categories"
    title="Expense Category"
    canEdit={canEdit}
    columns={[
      { key: 'name', label: 'Name' },
      { key: 'sortOrder', label: 'Sort Order' },
    ]}
    fields={[
      { name: 'name', label: 'Name', required: true, xs: 8 },
      { name: 'sortOrder', label: 'Sort Order', type: 'number', required: true, xs: 4, inputProps: { min: 0, step: 1 } },
    ]}
    validationSchema={schema}
    emptyValues={{ name: '', sortOrder: 0 }}
    toForm={(r) => ({ name: r.name || '', sortOrder: r.sortOrder ?? 0 })}
    toPayload={(v) => ({ name: v.name, sortOrder: Number(v.sortOrder) })}
  />
);

export default ExpenseCategoryMaster;
